import { render, staticRenderFns } from "./formsettingcar.vue?vue&type=template&id=011cdc11&scoped=true&"
import script from "./formsettingcar.vue?vue&type=script&lang=js&"
export * from "./formsettingcar.vue?vue&type=script&lang=js&"
import style0 from "./formsettingcar.vue?vue&type=style&index=0&id=011cdc11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011cdc11",
  null
  
)

export default component.exports